import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const OfferModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const token = decryptToken("accessToken") || "";
    const [load, setLoad] = useState(false);

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images/${isLoggedIn.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`);
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.error(error);
        }
    };

    console.log(data)
    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption.value);
        setData({ ...data, product: fullProduct });
    };

    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            ...data,
            user_id: isLoggedIn.main_id,
            user_name: isLoggedIn.full_name,
        };
        setLoad(true);
        try {
            const response = await fetch(`${url}/offer${data.id ? `/${data.id}` : ""}`, {
                method: data.id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();
            if (response.ok) {
                toast.success(data.id ? "Offer updated successfully" : "Offer saved successfully");
                sliderFetch();
                setIsOpen(false);
            } else {
                toast.error("Failed to save slider");
            }
        } catch (error) {
            console.error(error)
        }finally{
            setLoad(false)
        }


    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Create New Offer</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>

                    {/* Offer Title */}
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">Offer Heading</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={data.title}
                            onChange={handleChange}
                            placeholder="e.g. Exclusive Festive Offer"
                        />
                    </div>

                    {/* Offer Description */}
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">Offer Description</label>
                        <input
                            type="text"
                            id="description"
                            name="description"
                            value={data.description}
                            onChange={handleChange}
                            placeholder="Brief details about the offer"
                        />
                    </div>

                    {/* Offer Link */}
                    <div className="oms-form-group">
                        <label htmlFor="link" className="oms-form-label">Redirection Link</label>
                        <input
                            type="text"
                            id="link"
                            name="link"
                            value={data.link}
                            onChange={handleChange}
                            placeholder="Paste the product/category URL here"
                        />
                    </div>

                    {/* Offer Tagline */}
                    <div className="oms-form-group">
                        <label htmlFor="offer_name" className="oms-form-label">Offer Tagline</label>
                        <input
                            type="text"
                            id="offer_name"
                            name="offer_name"
                            value={data.offer_name}
                            onChange={handleChange}
                            placeholder="e.g. Flat 50% Off, Buy 1 Get 1 Free"
                        />
                    </div>

                    {/* Offer Image */}
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="image" className="oms-form-label">Main Image</label>
                        <button type="button" onClick={() => setShowImageModal(true)}>Upload Image</button>
                        <div>
                            {data.image && (
                                <img src={data.image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                            )}
                        </div>
                    </div>

                    {/* Image Modal */}
                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={(img) => handleImageSelect('image', img)}
                        multiple={false}
                        setImages={setImages}
                    />

                    {/* Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            load? <button type="button">Submiting...</button>:
                             <button type="submit">Submit</button>
                        }
                       
                    </div>
                </form>
            </div>
        </div>

    );
};


export default OfferModal;
